// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryDetailSubCategoriesStyles } from "@ces/Overrides/Widgets/Category/CategoryDetailSubCategories";
import LinkArrowRight from "@ces/XDL/Icons/LinkArrowRight";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, createLinkIconStyles, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.imageTitleWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: center;
        justify-content: center;
    `,
};

categoryDetailSubCategoriesStyles.container = {
    gap: 22,
    offsetCss: css`
        ${xScreen("lte", "sm")} {
            justify-content: center;
        }
    `,
};

categoryDetailSubCategoriesStyles.subCategoryItem = {
    width: [6, 6, 3, 3, 2],
};

categoryDetailSubCategoriesStyles.innerContainer = {
    css: css`
        width: 100%;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    color: "text",
    typographyProps: {
        size: 14,
        lineHeight: "22px",
        weight: fontConfig.weight.bold,
        css: css`
            text-align: center;
        `,
    },
    css: css`
        margin-bottom: 8px;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageClickable = {
    css: css`
        max-width: 145px;
        max-height: 145px;
        align-items: center;
        justify-content: center;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImage = {
    width: "143px",
    height: "143px",
    css: css`
        border-radius: 50%;
        border: 1px solid ${color("common.border")};
        img {
            object-fit: contain;
            aspect-ratio: 4 / 3;
        }
    `,
};

categoryDetailSubCategoriesStyles.subCategoryListWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        text-align: center;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryViewAllLink = {
    ...createLinkIconStyles({
        icon: LinkArrowRight,
        iconPosition: "right",
    }),
};

categoryDetailSubCategoriesStyles.subCategoryListViewAll = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageItem = {
    css: css`
        display: flex;
        justofy-content: center;
    `,
};
